import * as S from './styles'
import { usePartners } from './usePartners'
import { Image, Text } from '@/components'
import { Partner } from '@/service/api/home'

type PartnersContainerProps = {
  /**
   * Data of partners container
   *
   * @example
   * ```tsx
   * const data = {
   *  ...
   * }
   *
   * <PartnersContainer partnerData={data} />
   * ```
   */
  partnerData: Partner
}

export const PartnersContainer: React.FC<PartnersContainerProps> = ({
  partnerData,
}) => {
  const { fontSizes } = usePartners()

  const topLogos = partnerData.logos.slice(
    0,
    Math.trunc(partnerData.logos.length / 2),
  )
  const bottomLogos = partnerData.logos.slice(
    Math.trunc(partnerData.logos.length / 2),
    partnerData.logos.length,
  )

  if (!partnerData) return null

  return (
    <S.PartnerContainer>
      {partnerData.heading && (
        <Text align="center" size={fontSizes.title} color="primary">
          {partnerData.heading}
        </Text>
      )}

      <div className="logos">
        <div className="row">
          {topLogos.map((partner) => (
            <Image
              key={partner.alt}
              src={partner.src}
              alt={partner.alt}
              defaultSize={{
                height: partner.defaultSize.height,
                width: partner.defaultSize.width,
              }}
              responsiveSizes={{
                500: {
                  height: partner.defaultSize.height * 0.7,
                  width: partner.defaultSize.width * 0.7,
                },
              }}
            />
          ))}
        </div>
        <div className="row">
          {bottomLogos.map((partner) => (
            <Image
              key={partner.alt}
              src={partner.src}
              alt={partner.alt}
              defaultSize={{
                height: partner.defaultSize.height,
                width: partner.defaultSize.width,
              }}
              responsiveSizes={{
                500: {
                  height: partner.defaultSize.height * 0.7,
                  width: partner.defaultSize.width * 0.7,
                },
              }}
            />
          ))}
        </div>
      </div>
    </S.PartnerContainer>
  )
}
